
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqNhgIY7UYhoYFLO0c6yoxO4ZINIuC4iE1iLnuJUy0drAMeta } from "/codebuild/output/src659512614/src/src/pages/faq.vue?macro=true";
import { default as menu_45XTRYco7cl6l259PMhTaUEzXXlGaBQsB5xqW4nyKOGoMeta } from "/codebuild/output/src659512614/src/src/pages/menu.vue?macro=true";
import { default as indexekz5gQD2Fvi82ws_458bSxUkcH2BaacYfiiBDyIYI8A0EMeta } from "/codebuild/output/src659512614/src/src/pages/index.vue?macro=true";
import { default as contactLs6lViyk2xn9Ep7TNhdRFhP_kOIJGn79VhxcnuuLnxUMeta } from "/codebuild/output/src659512614/src/src/pages/contact.vue?macro=true";
import { default as tutorial7NlM8VFWZfW9FNpEWH4Nz4N_mFLKZCIpr4fBRZSJYjQMeta } from "/codebuild/output/src659512614/src/src/pages/tutorial.vue?macro=true";
import { default as agreementpvEJQe9cWBvF8CWBrAWG4STb5BM03_45vE1DAYYtsvPxQMeta } from "/codebuild/output/src659512614/src/src/pages/agreement.vue?macro=true";
import { default as about_45passovcyngAFvOxEn4FrLbPu_45MmdcVj8g4s08rA_CmUsh20Meta } from "/codebuild/output/src659512614/src/src/pages/about-pass.vue?macro=true";
import { default as indexgBktOclioqmJaya4ZkAyu4iApE9_45n8s7iXlvgfoXGvwMeta } from "/codebuild/output/src659512614/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93NnTZ_oi_aJLGXpLcsyN2oqSrMd5nKIsx0_45nN9FDYQ4kMeta } from "/codebuild/output/src659512614/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceVozAstrUl6P35JeFnzTMrLP7lzdZETrd3bqG4EzKj5sMeta } from "/codebuild/output/src659512614/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93BNsuFhFmVWaCACwG38FAdCNlxHd0aayo6KJ6aOP2rfQMeta } from "/codebuild/output/src659512614/src/src/pages/notice/[id].vue?macro=true";
import { default as indexHTvvn_45MYkRt5Hj8PNzllAga9fRzNXUdrJyre3qfBd_AMeta } from "/codebuild/output/src659512614/src/src/pages/coupon/index.vue?macro=true";
import { default as indexg9z6hoAH4w6OITW12_E05Sba_45yeeri_45eg4AAQ91B6_45oMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/index.vue?macro=true";
import { default as indexwFZviHMfhgNCXAdiqR_45gYa96Mq5jJJOzAP5bNF8Kj4oMeta } from "/codebuild/output/src659512614/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_930qNw1Nmo7Zdgac0Ao3FBq_QN_45GoGyLlp1PJpytLNpwsMeta } from "/codebuild/output/src659512614/src/src/pages/parking/[id].vue?macro=true";
import { default as indexqe4XcI05HoTfOh1Xi3Qdfz1uusZzcnKClgeY8cAce1YMeta } from "/codebuild/output/src659512614/src/src/pages/history/index.vue?macro=true";
import { default as indexPg8EWDRk_45Pt6sO1Crt_45B4lVBvI1n4I8F1q8cfw9x_457UMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/index.vue?macro=true";
import { default as indexjdI2bgmZh95WOi33jvL5TQ_vsKloeCwoiKv6udu3TrAMeta } from "/codebuild/output/src659512614/src/src/pages/sign-in/index.vue?macro=true";
import { default as index9gr70wHStHUcI3EQjQphkO8uIDjPP7A1mn2jxPq90dMMeta } from "/codebuild/output/src659512614/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavil7h6S0c8O1CV15QOKTTSx2E4GSkpvut3LI1B8yXjk6oMeta } from "/codebuild/output/src659512614/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editbUAV1nIdE3qOFhpKF5t9mgONid3HluF5_45WJ38bQtxS4Meta } from "/codebuild/output/src659512614/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement8lEwf2idVyXeb_45ocAedfb6xXefnQoq3zxot_h9gzOEEMeta } from "/codebuild/output/src659512614/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexhNoQcGHCUvmIjBKRizybt_GGmaL6UJErIJwTrZMeNfEMeta } from "/codebuild/output/src659512614/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dHphA6gRzroZzw79opq0M3Vk3YQjOwEeMHTNRc_458RzeoMeta } from "/codebuild/output/src659512614/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmTu2kaP4KssbKY3BC_45SkldzAP4YgRPhu07kWuoGvAhcUMeta } from "/codebuild/output/src659512614/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexvI4Tj2n3T7RalF1v8z0xngiqKdsUzJolMq3UPtvX_9AMeta } from "/codebuild/output/src659512614/src/src/pages/card/create/index.vue?macro=true";
import { default as indexspOQQGaDY5t4HAFx2YVGfbdQQ1je5vf1YBvNiG4EVuYMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmHitcLlq93kOLetb3nEDSiwO6nhA9DSjmYEt_45dFKJHm8Meta } from "/codebuild/output/src659512614/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmnXiEWQwID_45ZssUFIqkqSnYvpkkPDQep0S3lHMCc5WP8Meta } from "/codebuild/output/src659512614/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeNrYWuoQLHO0gft_wPbPOS3Q1ykx2gh2MBpbL8kdzmDwMeta } from "/codebuild/output/src659512614/src/src/pages/membership/complete.vue?macro=true";
import { default as registerPDwiI5JKITx4XR5alKjKfqi9PDcUOa_45NpsDhgiAkrIIMeta } from "/codebuild/output/src659512614/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_931ttbE1fDY28Y4zX5NGZ_454Kuse8uOoY7nswLwlBavbU8Meta } from "/codebuild/output/src659512614/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmn6Rlx5gbCuQqhGBOROpEcC3cilsWJPX0ZkuEdfNxeeYMeta } from "/codebuild/output/src659512614/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_931e9YoBfjAz7Vp2xGqPHm3i9rJq2h1G2_LqzV1Li_45_poMeta } from "/codebuild/output/src659512614/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexwOGGjqtht40YCDyq00UCFMggzG444VLO_P5gGCnYPVsMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codep60dqhIpKSqMJdZedLNnHg_4545hL8b8j9wu3VqeGVjnEMeta } from "/codebuild/output/src659512614/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeOL_45pICY5WOjQLP_PwDXRgkp_jmcpX9lxvGbNW2SB28IMeta } from "/codebuild/output/src659512614/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeHYw8Rz00tIm_jfREen5OjuFrrCYJljZRQ5YzTHXevxAMeta } from "/codebuild/output/src659512614/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register3bP_45TxKqcmm_45RSpaJlZBSSO8wZFoSim0JGkolxXF8U0Meta } from "/codebuild/output/src659512614/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeW2DYMnFh1J4R565SOixPCffGEG41l1WRRNUAThpaZo4Meta } from "/codebuild/output/src659512614/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexO3e4OaSuyILmTW7e1XGjDs2ZEjpVEB3Ue7Si2mv4IwQMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmPAqKyfIdOgsVaA1iF3gwDXkgTT2lTt8167qdBK3im6UMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeDgBUHH6zZub0Um1krnOMgQTM7y2b79uFWQxsA60EEKAMeta } from "/codebuild/output/src659512614/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index8Jjt7flZgboo6J_IRY_IWvOfKcMNM_6_AT3rHtAmQY0Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ARbIRoGjKR6VsabY3WxyOC26pQIrIiXtu_ZnnmDGHioMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeXgcNH_Vv0O_45AzsHuzh3eKazewXcLM69mTYLt_45xlopmIMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliaslqagztHet6EK87SkCbY_mDzw4QT6Oto8rpt9n1G8AB0Meta } from "/codebuild/output/src659512614/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampledHAOxpE3kYi_ppNHKWysKSJONc7TRjum55Tz2_45uKXrQMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailgbntXnQswN19Jr3Fe8pZ7zAvSe8iHOS5orxF_45u1FlIMMeta } from "/codebuild/output/src659512614/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmSHwXmt45Yw43A6NphrjxVrzimtNt8JqkfiyxcNaAc7cMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent4sbrELSK5K4ascK0B4lTl_A1ZHQX1QvFrQJHIwCZWVEMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmzPHhvTfcN_45YcomwhCgJp_45r9jfSK1Vqs8ukPBzcZ2rKgMeta } from "/codebuild/output/src659512614/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate0U13139ppsKS__45ntawLHVj6NoYIfBmS1oUF2hdfB_24Meta } from "/codebuild/output/src659512614/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete5mkh4mFiZozsYt9tntu4h3fCZ71iPzzWB_dWp7irBS0Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeO3zLTJEZWDcencOXYtuhGZmpscEmA2LK16FvIH52DKoMeta } from "/codebuild/output/src659512614/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordixIC4vPcMaX8f7NnSCdxcmhXw7sSwTGBAyQoShnu5jMMeta } from "/codebuild/output/src659512614/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias_zXOwRa3sV6BmpFFRAsH_wNgq0q_XQpGSfapyrE_kGkMeta } from "/codebuild/output/src659512614/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerltzEfft6AImskp6LWxt9oZBap43APpiDRbddzFqnieoMeta } from "/codebuild/output/src659512614/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeEG3nsfkeL3phmkyNFwaCKFKApPS6kHRbfJjCf7vlS_IMeta } from "/codebuild/output/src659512614/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexdC8_45jNO_I51U2QjOoOwmzIObdoKda4OaIWKRzvcRJLQMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index_45LBuaRiyAiqJPIA6BzLM_KCYp8LFYJ2C7_axzEZkiVgMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index58Q9RgM_xSUKmt4qwI0BJGKmrFG_mtk30XvLDzIgrqQMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexSM048Cp9q81_45PgLcZZ_jZCJbKjJ3joCcB9vwWLJ7AqUMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatepZO0Uj7B1rPmIhx6Irg_45gUMqvh8yrQpJdte8ieGVw_45UMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete61slNUtKP9wl4dKM9_45hhYeDQmTc0FZRwEvG2hb4RR80Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmtiE_6kafyMU71QP3_45FXIRy2T923uBLC1z8N4XJa16x8Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexyHKswRQgnL5bM0Z1xKP8LEGehPRhHJKwTZPh8Xf62_45AMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completexkefiCI6d7PJhqMR3yiz_j8yJf8jpwzN5ZI2O2MLMWcMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatepWrzIoKM6etS2dosOdkqx2WGPqFx81fHCj5Xjfm4_45e4Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexV9WHb4YUoKuXErTCWn14fO_59I_45ensp_WXo9dSRgutkMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index8Q1U8cwyCVaLrq4iewLomcT0RiHWntwNaRZmqY_dJNoMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeHZOjVVywYxQkjuFvRjKFxQuRSObD8vFCjIzKj7TUXewMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexRVBHEkFDc2a7ykO6gTevhBOek0BhCYelP_45my9LKb2a8Meta } from "/codebuild/output/src659512614/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codedQ4psij2NlwzW73SFtKcvAtsihhk7EmdjvLQxSyVaEoMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexozY8XGnIaY4cVTydNyyamH7wU5FlOq7lTvId6pQtjE0Meta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexl8_HQo9BFLacbSQo43EKt2m_45YrW6F9xBERnytbHBJ7EMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexPdrOauPyxIOWJALyp6RtClKMzILfUcARxW8HPBeLAesMeta } from "/codebuild/output/src659512614/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update5rTD5rJ7CX1W8VGRm1YhEAHqOr0xAkmgRQQPvlx5bUIMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm51t1uxgqAutF7c5yIwB_cmsu2llBtMussrJGxgOgdJQMeta } from "/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src659512614/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu_45XTRYco7cl6l259PMhTaUEzXXlGaBQsB5xqW4nyKOGoMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexekz5gQD2Fvi82ws_458bSxUkcH2BaacYfiiBDyIYI8A0EMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src659512614/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src659512614/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src659512614/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src659512614/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src659512614/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexHTvvn_45MYkRt5Hj8PNzllAga9fRzNXUdrJyre3qfBd_AMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexqe4XcI05HoTfOh1Xi3Qdfz1uusZzcnKClgeY8cAce1YMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexjdI2bgmZh95WOi33jvL5TQ_vsKloeCwoiKv6udu3TrAMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index9gr70wHStHUcI3EQjQphkO8uIDjPP7A1mn2jxPq90dMMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src659512614/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src659512614/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexvI4Tj2n3T7RalF1v8z0xngiqKdsUzJolMq3UPtvX_9AMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmHitcLlq93kOLetb3nEDSiwO6nhA9DSjmYEt_45dFKJHm8Meta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmnXiEWQwID_45ZssUFIqkqSnYvpkkPDQep0S3lHMCc5WP8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeNrYWuoQLHO0gft_wPbPOS3Q1ykx2gh2MBpbL8kdzmDwMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerPDwiI5JKITx4XR5alKjKfqi9PDcUOa_45NpsDhgiAkrIIMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmn6Rlx5gbCuQqhGBOROpEcC3cilsWJPX0ZkuEdfNxeeYMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codep60dqhIpKSqMJdZedLNnHg_4545hL8b8j9wu3VqeGVjnEMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeOL_45pICY5WOjQLP_PwDXRgkp_jmcpX9lxvGbNW2SB28IMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeHYw8Rz00tIm_jfREen5OjuFrrCYJljZRQ5YzTHXevxAMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register3bP_45TxKqcmm_45RSpaJlZBSSO8wZFoSim0JGkolxXF8U0Meta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmPAqKyfIdOgsVaA1iF3gwDXkgTT2lTt8167qdBK3im6UMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeDgBUHH6zZub0Um1krnOMgQTM7y2b79uFWQxsA60EEKAMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index8Jjt7flZgboo6J_IRY_IWvOfKcMNM_6_AT3rHtAmQY0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeXgcNH_Vv0O_45AzsHuzh3eKazewXcLM69mTYLt_45xlopmIMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampledHAOxpE3kYi_ppNHKWysKSJONc7TRjum55Tz2_45uKXrQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailgbntXnQswN19Jr3Fe8pZ7zAvSe8iHOS5orxF_45u1FlIMMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmSHwXmt45Yw43A6NphrjxVrzimtNt8JqkfiyxcNaAc7cMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent4sbrELSK5K4ascK0B4lTl_A1ZHQX1QvFrQJHIwCZWVEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmzPHhvTfcN_45YcomwhCgJp_45r9jfSK1Vqs8ukPBzcZ2rKgMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete5mkh4mFiZozsYt9tntu4h3fCZ71iPzzWB_dWp7irBS0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeO3zLTJEZWDcencOXYtuhGZmpscEmA2LK16FvIH52DKoMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordixIC4vPcMaX8f7NnSCdxcmhXw7sSwTGBAyQoShnu5jMMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src659512614/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerltzEfft6AImskp6LWxt9oZBap43APpiDRbddzFqnieoMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeEG3nsfkeL3phmkyNFwaCKFKApPS6kHRbfJjCf7vlS_IMeta || {},
    component: () => import("/codebuild/output/src659512614/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src659512614/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src659512614/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]